function Footer() {
   return (
    <footer>&copy;2024</footer>
   ); 
}

export default Footer;